import { apiInstance } from '@core/api/instance';
import { IVehicleMonitoringApi } from '@modules/vehicle-monitoring/types/api';

export const VehicleMonitoring: IVehicleMonitoringApi = {
  index: ({ view }) => apiInstance().get(`/NewTms/VehicleMonitoring/index?view=${view}`)
};
